import React from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'
import LoginPage from './pages/LoginPage'
import ChatPage from './pages/ChatPage'
import { AuthProvider } from './context/AuthContext'
import './styles/main.scss'

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/chats" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/chat" element={<Navigate to="/chats" replace />} />
          <Route path="/chats" element={<ChatPage />} />
          <Route path="/chats/:chatId" element={<ChatPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App
